import {
  Button,
  Heading,
  Stack,
  Text,
  Link,
  FormControl,
  FormLabel,
  FormErrorMessage
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { Formik, Field, Form } from "formik";

import StyledInput from "../components/StyledInput";

function QuickDetailsView() {
  const validate = (value) => {
    if (!value) return "Please enter/select a value";
  };

  return (
    <Formik initialValues={{ name: "", lname: "" }}>
      {({ values, isValid, dirty }) => {
        return (
          <>
            <Form autoComplete="off">
              <Stack py={2} px={4} spacing={7} flex="1 0 auto">
                <Heading size="md">A few quick details first</Heading>
                <Field name="name" validate={validate}>
                  {({ field, form }) => (
                    <FormControl
                      id="name"
                      isInvalid={form.errors.name && form.touched.name}
                    >
                      <FormLabel fontWeight="bold">First name</FormLabel>
                      <StyledInput id="name" {...field} />
                      <FormErrorMessage>{form.errors.name}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Stack>
                  <Field name="lname" validate={validate}>
                    {({ field, form }) => (
                      <FormControl
                        id="lname"
                        isInvalid={form.errors.lname && form.touched.lname}
                      >
                        <FormLabel fontWeight="bold">Last name</FormLabel>
                        <StyledInput id="lname" {...field} />
                        <FormErrorMessage>{form.errors.lname}</FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                </Stack>
                <Stack pt={4}>
                  <Heading size="sm">Get your information pack</Heading>
                  <Text fontSize="13px" mb={2}>
                    Our easy-to-read information pack is filled with lots of
                    handy information and our recommendations for you. You’ll
                    find this useful when talking with dealers or simply to read
                    later. We'll just need your email address so we can send it.
                  </Text>
                  <Text fontSize="13px" mb={4}>
                    We won't share your email address with anyone else, and will
                    only email you the information pack and your results.
                  </Text>
                  <StyledInput placeholder="example@email.com" />
                </Stack>
                <Link
                  as={RouterLink}
                  to={`/quiz-questions/1/${values.name}/${values.lname}`}
                >
                  <Button
                    colorScheme="blue"
                    isDisabled={!isValid || !dirty}
                    size="lg"
                  >
                    Let's go
                  </Button>
                </Link>
              </Stack>
            </Form>
          </>
        );
      }}
    </Formik>
  );
}

export default QuickDetailsView;
